import Search from 'assets/icons/fa/search.svg'

Search.displayName = 'Search'
export default Search
